import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import transportPageReducer from './TransportPageReducer';

const rootReducer = (history) =>
	combineReducers({
		router: connectRouter(history),

		transportPageReducer
	});

export default rootReducer;
